/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import AppRouter from "./App";
import { initPostHog } from "./posthog";

const elem = document.getElementById("root")!;

async function loadRuntimeConfig() {
  try {
    const response = await fetch(
      new URL("./ballah-runtime-config.json", window.location.href).toString(),
      { cache: "no-store" },
    );
    if (!response.ok) {
      return;
    }
    window.__BALLAH_RUNTIME_CONFIG__ = await response.json();
  } catch {
    // PostHog is optional. The app should still render if config loading fails.
  }
}

async function bootstrap() {
  await loadRuntimeConfig();
  initPostHog();

  const app = (
    <StrictMode>
      <AppRouter />
    </StrictMode>
  );

  if (import.meta.hot) {
    // With hot module reloading, `import.meta.hot.data` is persisted.
    const root = (import.meta.hot.data.root ??= createRoot(elem));
    root.render(app);
  } else {
    // The hot module reloading API is not available in production.
    createRoot(elem).render(app);
  }
}

void bootstrap();
